export default __webpack_public_path__ + "static/media/Button.971c7013.png";